import type { AlertInfo } from '@/task-manager/entities/alert-info';

import type { GetCardDetailViewOutputAlertInfos } from '../fetch-client';

import { alertStatusMapper } from './alert-status';
import { alertTypeMapper } from './alert-type';

export function alertInfoMapper(
  data: GetCardDetailViewOutputAlertInfos,
): AlertInfo {
  return {
    status: alertStatusMapper(data.status),
    type: alertTypeMapper(data.alert_type),
    suggestedAction: data.suggested_action,
    resolved: Boolean(data.resolved),
    statusChangedAt: new Date(data.status_changed_date),
  };
}
